import moment from "moment";

export function formatDate(date) {
  if (moment(date, "DD-MM-YYYY", true).isValid()) {
    return date;
  }
  return moment(date).format("DD-MM-YYYY");
}

export function formatDate2(date) {
  if (moment(date, "DD/MM/YYYY", true).isValid()) {
    return date;
  }
  return moment(date).format("DD/MM/YYYY");
}

export function dateCheck(date) {
  const today = new Date();
  const inputDate = new Date(date);

  // Set time to midnight to compare only the date part
  today.setHours(0, 0, 0, 0);
  inputDate.setHours(0, 0, 0, 0);

  return today >= inputDate;
}
 //  7th July 2025
export function formatDate3(dateStr) {
  if (!dateStr) return ''
  const date = new Date(dateStr)
  const day = date.getDate()
  const month = date.toLocaleString('en-US', { month: 'short' }) // "Jan", "Feb", etc.
  const year = date.getFullYear()
  
  return `${day} ${month} ${year}`
}

export function formatDate4(dateStr) {
  if (!dateStr) return ''
  
  const [day, month, year] = dateStr.split('-')
  const date = new Date(year, parseInt(month) - 1, day)

  const formattedDay = String(date.getDate()).padStart(2, '0')
  const formattedMonth = date.toLocaleString('en-US', { month: 'long' })
  const formattedYear = date.getFullYear()

  return `${formattedDay}-${formattedMonth}-${formattedYear}`
}

// Show Training Date 

export function formatDateRange(startDate, endDate) {
  // Date ko split karke object banana
  function parseDate(dateStr) {
    const [day, month, year] = dateStr.split("-");
    return new Date(`${year}-${month}-${day}`); // ISO format
  }

  // Month names array
  const months = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];

  const start = parseDate(startDate);
  const end = parseDate(endDate);

  const startDay = start.getDate();
  const startMonth = months[start.getMonth()];
  const startYear = start.getFullYear();

  const endDay = end.getDate();
  const endMonth = months[end.getMonth()];
  const endYear = end.getFullYear();

  // Same date check
  if (start.getTime() === end.getTime()) {
    return `( ${startDay} ${startMonth} ${startYear})`;
  } else {
    return `( ${startDay} ${startMonth} ${startYear} - ${endDay} ${endMonth} ${endYear})`;
  }
}
